import { ServiceBase } from '../../../../../../core/services/ServiceBase'
import BusinessYearsProxy from './proxy'

class BusinessYearsService extends ServiceBase {
  getBusinessYearsTable(params) {
    return this.getData(() => BusinessYearsProxy.getBusinessYearsTable(params))
  }

  exportBusinessYears(params) {
    return this.getFileDownload(() =>
      BusinessYearsProxy.exportBusinessYears(params),
    )
  }
}

export default new BusinessYearsService()
